import { Dialog, Portal } from "@ark-ui/react";
import { cn } from "@base/lib/utils";
import type { ComponentProps, RefObject } from "react";

type CustomProps = {
  container?: RefObject<HTMLElement>;
  usePortal?: boolean;
};
type Props = ComponentProps<typeof Dialog.Content> & CustomProps;

const Content = ({ children, container, className, usePortal = true, ...rest }: Props) => {
  return (
    <Portal container={container} disabled={!usePortal}>
      <Dialog.Backdrop
        className={cn("fixed inset-0 w-screen h-screen bg-black opacity-50 backdrop-blur-sm z-dialogBackdrop")}
      />
      <Dialog.Positioner className="flex overflow-auto fixed top-0 left-0 justify-center items-center w-screen h-screen z-dialog">
        <Dialog.Content
          className={cn(
            "min-w-[312px] w-[312px] bg-white rounded-16 shadow-s relative pointer-events-auto",
            "[&:is([open],[data-open],[data-state=open])]:animate-dialogIn",
            "[&:is([closed],[data-closed],[data-state=closed])]:animate-dialogOut",
            className,
          )}
          {...rest}
        >
          {children}
        </Dialog.Content>
      </Dialog.Positioner>
    </Portal>
  );
};

export default Content;
